import { render, staticRenderFns } from "./CommentSideBar.vue?vue&type=template&id=2f1d8bcf&"
import script from "./CommentSideBar.vue?vue&type=script&lang=ts&"
export * from "./CommentSideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports